import {gsap} from 'gsap'
import {ScrollTrigger} from 'gsap/ScrollTrigger.js'
import Swiper from 'swiper'
import {Autoplay,Navigation,Pagination} from 'swiper/modules'

gsap.registerPlugin(ScrollTrigger)
// ScrollTrigger.normalizeScroll(true)
ScrollTrigger.config({
  autoRefreshEvents: 'load,DOMContentLoaded' // notice there's no "resize"
})
  ; (function($) {
    'use strict'

    var Common = {
      init: function() {
        this.headerSetup()
        this.accordionSetup()
        this.simpleAnimation()
        this.marqueeSetup()
        this.circularTextSetup()
        this.handleVideo()

        if($('.section-hero-slider').length > 0) {
          this.heroSlider()
        }
        if($('.section-products-slider').length > 0) {
          this.productsSlider()
        }
        if($('.section-expertise').length > 0) {
          this.expertiseSetup()
        }
        if($('.section-news').length > 0) {
          this.newsSlider()
        }
        if($('.section-testimonial').length > 0) {
          this.testimonialSetup()
        }
      },

      // Circular Text Setup
      circularTextSetup: function() {
        if($('.circular-svg').length === 0) return

        gsap.to('.circular-svg g',{
          rotation: 360,
          transformOrigin: '50% 50%',
          repeat: -1,
          ease: 'linear',
          duration: 12
        })
      },

      // AccordionSetup
      accordionSetup: function() {
        // (Optional) Active an item if it has the class "is-active"
        $('.accordion > .accordion-item.is-active').children('.accordion-panel').slideDown()

        // Variable to track if transition is happening
        var isTransitioning = false

        $('.accordion > .accordion-item').click(function() {
          // Prevent click if any transition is happening
          if(isTransitioning) {
            return
          }

          // Set transitioning state
          isTransitioning = true

          var $this = $(this)

          // Toggle only the clicked item
          $this
            .toggleClass('is-active')
            .children('.accordion-panel')
            .slideToggle('ease-out',function() {
              // All animations have completed, allow clicking again
              isTransitioning = false

              // Update ScrollTrigger for all sections
              ScrollTrigger.refresh()
            })
        })
      },

      // Header Setup
      headerSetup: function() {
        let lastScrollTop = 0
        let ticking = false

        window.addEventListener('scroll',() => {
          if(window.menuOpen) return

          if(!ticking) {
            window.requestAnimationFrame(() => {
              const scrollTop = window.pageYOffset || document.documentElement.scrollTop
              const threshold = 10 // Add threshold to reduce jitter

              if(scrollTop >= 100) {
                $('.page-header').addClass('scrolled')

                if(Math.abs(scrollTop - lastScrollTop) > threshold) {
                  if(scrollTop > lastScrollTop) {
                    $('.page-header').addClass('hide')
                  } else {
                    $('.page-header').removeClass('hide')
                  }
                  lastScrollTop = scrollTop
                }
              } else {
                $('.page-header').removeClass('scrolled hide')
                lastScrollTop = 0
              }

              ticking = false
            })

            ticking = true
          }
        })

        // Handle Open Search Header
        const $openSearchForm = $('.page-header #open-search-form')
        const $searchForm = $('.page-header .search-wrapper')

        $openSearchForm.on("click",function() {
          $searchForm.addClass('active')
        })
      },

      // Expertise Setup
      expertiseSetup: function() {
        const $section = $('.section-expertise')
        const $listExpertise = $section.find('.list-expertise')
        const $expertiseItems = gsap.utils.toArray('.expertise-item')
        if(!$section.length || !$listExpertise.length || !$expertiseItems.length) return

        const mm = gsap.matchMedia()

        mm.add(
          {
            isDesktop: '(min-width: 769px)',
            isTablet: '(max-width: 768px)',
          },
          (context) => {
            const {isDesktop} = context.conditions

            function getScrollMetrics() {
              const visibleW = $listExpertise.outerWidth()
              const totalW = $listExpertise[0].scrollWidth
              const paddingLeft = parseInt($listExpertise.css('padding-left')) || 0
              const maxScroll = totalW - visibleW + paddingLeft
              return {visibleW,totalW,maxScroll}
            }

            if(isDesktop) {
              const {visibleW,totalW,maxScroll} = getScrollMetrics();

              // Tăng chiều dài scroll để kéo dài thời gian
              const scrollDistance = maxScroll * 5;

              const expertiseTimeline = gsap.timeline({
                scrollTrigger: {
                  trigger: $section[0],
                  start: 'top top',
                  end: `+=${scrollDistance}`,
                  pin: true,
                  scrub: true,
                  invalidateOnRefresh: true,
                  id: 'expertise',
                  // markers: true,
                },
              });

              // Đặt trạng thái ban đầu cho line
              gsap.set('.line-foreground',{
                scaleX: 0,
                transformOrigin: 'left center',
                willChange: 'transform',
              });

              const itemWidth = $expertiseItems[0].offsetWidth;
              const totalItems = $expertiseItems.length;

              // Kích hoạt item đầu tiên ngay từ đầu
              const $firstItem = $($expertiseItems[0]);
              $('.expertise-item').removeClass('active');
              $firstItem.addClass('active');
              gsap.set($firstItem.find('.expertise-img'),{autoAlpha: 1});
              gsap.set($firstItem.find('.number-wrap'),{autoAlpha: 1});

              // Cuộn ngang list - delay nhẹ để tránh item 1 bị che
              const offsetStart = 0.05;
              const earlyOffset = 0.1;

              expertiseTimeline.to(
                $listExpertise,
                {
                  x: () => `-${maxScroll}`,
                  ease: 'none',
                },
                offsetStart
              );


              // Duyệt qua từng item và xử lý
              $expertiseItems.forEach((item,index) => {
                const $item = $(item);

                const scrollPos = (index / totalItems) * (1 - offsetStart);
                const actualScrollPos = scrollPos + offsetStart - earlyOffset;

                expertiseTimeline.call(() => {
                  $('.expertise-item').removeClass('active');
                  $item.addClass('active');
                },null,actualScrollPos);

                expertiseTimeline
                  .fromTo(
                    $item.find('.expertise-img'),
                    {autoAlpha: 0},
                    {autoAlpha: 1,duration: 0.3},
                    actualScrollPos
                  )
                  .fromTo(
                    $item.find('.number-wrap'),
                    {autoAlpha: 0.4},
                    {autoAlpha: 1,duration: 0.3},
                    actualScrollPos
                  );
              });

              // 🎯 DÙNG ScrollTrigger.onUpdate để điều khiển scaleX mượt
              ScrollTrigger.create({
                trigger: $section[0],
                start: 'top top',
                end: `+=${scrollDistance}`,
                scrub: true,
                onUpdate: (self) => {
                  const progress = self.progress;
                  gsap.set('.line-foreground',{
                    scaleX: progress,
                  });
                },
              });

              ScrollTrigger.refresh(); // đảm bảo update kích thước
            }


            else {
              // Mobile vertical scroll setup
              gsap.to('.line-foreground',{
                height: '100%',
                ease: 'none',
                scrollTrigger: {
                  trigger: $section[0],
                  start: 'top top',
                  end: 'bottom center',
                  scrub: true,
                  invalidateOnRefresh: true,
                  // markers: true,
                },
              })

              // Reveal per item on scroll
              $expertiseItems.forEach((section) => {
                const $section = $(section)
                gsap.fromTo(
                  [$section.find('.number-wrap'),$section.find('.expertise-img')],
                  {autoAlpha: (index) => (index === 0 ? 0.4 : 0)},
                  {
                    autoAlpha: 1,
                    scrollTrigger: {
                      trigger: section,
                      start: 'top center',
                      end: 'bottom center',
                      scrub: true,
                      invalidateOnRefresh: true,
                      // markers: true,
                    },
                  }
                )
              })
            }
          }
        )

        return () => {
          mm.kill()
        }
      },

      // Simple Animation
      simpleAnimation: function() {
        const triggerSections = document.querySelectorAll('.anim-trigger')
        if(!triggerSections.length) return

        const mm = gsap.matchMedia()
        const triggers = []

        mm.add(
          {
            isMobile: '(max-width: 768px)',
            isDesktop: '(min-width: 769px)'
          },
          (context) => {
            const {isMobile} = context.conditions

            triggerSections.forEach((trigger) => {
              const targets = trigger.querySelectorAll('.anim-target')
              if(!targets.length) return

              // Set initial state
              gsap.set(targets,{opacity: 0,y: 50})

              // Create timeline for animations
              const tl = gsap.timeline({paused: true})
              tl.to(targets,{
                duration: isMobile ? 0.8 : 1, // Shorter duration on mobile
                opacity: 1,
                y: 0,
                stagger: isMobile ? 0.15 : 0.2, // Faster stagger on mobile
                ease: 'power2.out'
              })

              // Create ScrollTrigger
              const st = ScrollTrigger.create({
                trigger: trigger,
                start: 'top 70%', // Slightly earlier for smoother reveal
                once: true,
                invalidateOnRefresh: true,
                onEnter: () => tl.play()
              })
              triggers.push(st)
            })

            return () => {
              triggers.forEach((trigger) => trigger.kill())
            }
          }
        )

        return () => {
          mm.kill() // Cleanup matchMedia
        }
      },

      // Marquee Setup
      marqueeSetup: function() {
        function initMarquee($marquee,options = {}) {
          const duration = options.duration || 20
          const direction = options.direction || 'left' // có thể mở rộng

          const $items = $marquee.children()
          if($items.length === 0) return

          // Bọc lại toàn bộ span vào một track nếu chưa có
          if(!$marquee.find('.marquee-track').length) {
            const $track = $('<div class="marquee-track"></div>')
            $track.append($items)
            $marquee.append($track)
          }

          const $track = $marquee.find('.marquee-track')
          const $originalItems = $track.children()

          // Clone để tạo loop vô tận
          $originalItems.each(function() {
            const $clone = $(this).clone()
            $track.append($clone)
          })

          const totalWidth = $track[0].scrollWidth / 2

          // Dùng GSAP để animate marquee
          const marqueeTl = gsap.to($track,{
            x: direction === 'left' ? -totalWidth : totalWidth,
            duration: duration,
            ease: 'none',
            repeat: -1
          })

          // Pause khi hover
          // $marquee.on('mouseenter', () => marqueeTl.pause())
          // $marquee.on('mouseleave', () => marqueeTl.resume())
        }

        $('.marquee').each(function() {
          initMarquee($(this),{duration: $(this).data('duration')})
        })
      },

      // Hero Slider
      heroSlider: function() {
        const swiper = new Swiper('.section-hero-slider .hero-slider',{
          modules: [Autoplay,Pagination],
          loop: true,
          spaceBetween: 0,
          slidesPerView: 1,
          autoplay: {
            delay: 2500,
            disableOnInteraction: false,
            pauseOnMouseEnter: true // Add pause on hover
          },
          pagination: {
            el: '.swiper-pagination',
            clickable: true
          },
          breakpoints: {}
        })

        return () => {
          swiper.destroy(true,true) // Add cleanup
        }
      },

      // Products Slider
      productsSlider: function() {
        $('.product-slider').each(function(index) {
          const $slider = $(this);
          const uniqueId = `slider-${index + 1}`;

          let smSlidePerView = $(this).data('sm-slide-per-view')
          let mdSlidePerView = $(this).data('md-slide-per-view')
          let lgSlidePerView = $(this).data('lg-slide-per-view')

          console.log('smSlidePerView',smSlidePerView);
          console.log('mdSlidePerView',mdSlidePerView);
          console.log('mdSlidePerView',mdSlidePerView);

          // Gán ID unique cho slider
          $slider.attr('id',uniqueId);

          // Gán class unique cho navigation elements
          $slider.find('.swiper-pagination').addClass(`pagination-${uniqueId}`);
          $slider.find('.swiper-button-next').addClass(`next-${uniqueId}`);
          $slider.find('.swiper-button-prev').addClass(`prev-${uniqueId}`);

          // Khởi tạo Swiper
          let swiper = new Swiper($slider[0],{
            modules: [Autoplay,Pagination,Navigation],
            loop: true,
            slidesPerView: 2,
            spaceBetween: 8,
            pagination: {
              el: `.pagination-${uniqueId}`,
              clickable: true
            },
            navigation: {
              nextEl: `.next-${uniqueId}`,
              prevEl: `.prev-${uniqueId}`,
            },
            updateOnWindowResize: true,
            breakpoints: {
              480: {slidesPerView: smSlidePerView},
              768: {
                slidesPerView: mdSlidePerView,
                spaceBetween: 8
              },
              1024: {
                slidesPerView: lgSlidePerView,
                spaceBetween: 20,
              },
            }
          });

          console.log(`Initialized slider: ${uniqueId}`);
        });
      },

      // News Setup
      newsSlider: function() {
        const $section = $('.section-news')
        const $newsSlider = $section.find('.news-slider')

        const swiper = new Swiper($newsSlider[0],{
          modules: [Autoplay,Navigation],
          loop: true,
          spaceBetween: 40,
          slidesPerView: 1.5,
          autoplay: {
            delay: 2500,
            disableOnInteraction: false,
            pauseOnMouseEnter: true // Add pause on hover
          },
          navigation: {
            prevEl: $section.find('.swiper-button-prev')[0],
            nextEl: $section.find('.swiper-button-next')[0]
          },
          breakpoints: {
            1024: {
              slidesPerView: 3,
              spaceBetween: 40
            }
          }
        })

        return () => {
          swiper.destroy(true,true) // Add cleanup
        }
      },

      // Testimonial
      testimonialSetup: function() {
        const $section = $('.section-testimonial')
        const $testimonialSlider = $section.find('.testimonial-slider')

        const testimonialSwiper = new Swiper($testimonialSlider[0],{
          modules: [Autoplay,Navigation],
          speed: 600,
          autoplay: {
            delay: 3000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true
          },
          spaceBetween: 10,
          loop: true,
          slidesPerView: 1,
          grabCursor: false,
          navigation: {
            prevEl: $section.find('.swiper-button-prev')[0],
            nextEl: $section.find('.swiper-button-next')[0]
          }
        })

        return () => {
          testimonialSwiper.destroy(true,true)
        }
      },

      // Handle play video in @video.html when clicking the play button
      handleVideo: function() {
        const $videoSection = $('.section-video')
        if(!$videoSection.length) return

        const $videoHolder = $videoSection.find('.video-holder')
        const $video = $videoHolder.find('video')
        const $playBtn = $videoHolder.find('.play-btn')

        // Play video on click play button
        $playBtn.on('click',function() {
          if($video.length) {
            $video[0].play()
            $video.attr('controls',true)
            $playBtn.hide()
          }
        })

        // Optionally, hide play button if video is played by other means
        $video.on('play',function() {
          $playBtn.hide()
          $video.attr('controls',true)
        })
      },
    }

    // Khởi chạy khi DOM ready
    $(function() {
      Common.init()
    })
  })(jQuery)
